// src/components/auth/OfflineAuthIndicator.js - Indicatore modalità auth offline
import React from 'react';
import { WifiOff, Shield, Clock } from 'lucide-react';

const OfflineAuthIndicator = ({ 
  isOfflineMode, 
  lastOnlineLogin, 
  className = "" 
}) => {
  if (!isOfflineMode) return null;

  const daysSinceLogin = lastOnlineLogin 
    ? Math.floor((Date.now() - lastOnlineLogin) / (1000 * 60 * 60 * 24))
    : null;

  const formatLastLogin = () => {
    if (!lastOnlineLogin) return 'Sconosciuto';
    
    const date = new Date(lastOnlineLogin);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    
    if (isToday) {
      return `Oggi alle ${date.toLocaleTimeString('it-IT', { 
        hour: '2-digit', 
        minute: '2-digit' 
      })}`;
    }
    
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();
    
    if (isYesterday) {
      return `Ieri alle ${date.toLocaleTimeString('it-IT', { 
        hour: '2-digit', 
        minute: '2-digit' 
      })}`;
    }
    
    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getIndicatorColor = () => {
    if (!daysSinceLogin) return 'orange';
    
    if (daysSinceLogin <= 1) return 'green';
    if (daysSinceLogin <= 3) return 'yellow';
    if (daysSinceLogin <= 7) return 'orange';
    return 'red';
  };

  const color = getIndicatorColor();
  const colorClasses = {
    green: 'bg-green-50 border-green-200 text-green-800',
    yellow: 'bg-yellow-50 border-yellow-200 text-yellow-800',
    orange: 'bg-orange-50 border-orange-200 text-orange-800',
    red: 'bg-red-50 border-red-200 text-red-800'
  };

  return (
    <div className={`flex items-center space-x-2 px-3 py-2 rounded-lg border ${colorClasses[color]} ${className}`}>
      <WifiOff className="w-4 h-4 flex-shrink-0" />
      <div className="flex items-center space-x-1 text-xs">
        <Shield className="w-3 h-3" />
        <span className="font-medium">Modalità Offline</span>
      </div>
      {lastOnlineLogin && (
        <div className="flex items-center space-x-1 text-xs opacity-75">
          <Clock className="w-3 h-3" />
          <span title={`Ultimo accesso online: ${formatLastLogin()}`}>
            {daysSinceLogin === 0 ? 'Oggi' : 
             daysSinceLogin === 1 ? 'Ieri' : 
             `${daysSinceLogin}g fa`}
          </span>
        </div>
      )}
    </div>
  );
};

export default OfflineAuthIndicator;